<template>
  <div>
    <div class="news-page page" v-if="displayNewsList">
      <!-- 顶部1 -->
      <page-top></page-top>
      <!-- 头部 -->
      <Header :word="keyWord"></Header>
      <!-- 主体 -->
      <main class="main">
        <section class="breadcrumb-plate w">
          <div class="label">当前位置：</div>
          <breadcrumb />
        </section>
        <section class="content w">
          <div class="c-left">
            <tabbar
              :tabData="tabList"
              @changeSecTab="changeSecTab"
            ></tabbar>
          </div>
          <div class="c-right">
            <list-item
              :list="newsList"
              type="arrows"
              :dash="true"
              @toDetail="toDetail"
            ></list-item>

            <div class="m-bot" v-if="newsList.list?.length > 0 && pageCount>=pageSize">
              <el-pagination
                background
                layout="prev, pager, next"
                prev-text="上一页"
                next-text="下一页"
                :page-size="pageSize"
                :total="pageCount"
                @current-change="changePageClick"
              >
              </el-pagination>
            </div>
            <el-empty
              description="暂无相关信息"
              v-if="newsList.list?.length == 0"
              style="height: 492px"
            ></el-empty>
          </div>
        </section>
      </main>
      <!-- 底部 -->
      <Footer></Footer>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import Tabbar from "@/components/list/tabbar.vue";
import listItem from "@/components/list/list-item.vue";

import Breadcrumb from "@/components/common/breadcrumb";
import { searchArticle } from "@/api/home/home.js";

export default {
  components: { pageTop, Header, Footer, Tabbar, Breadcrumb, listItem },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: null,
      newsList: [],
      keyWord: "",

    };
  },
  created() {
    this.keyWord = this.$route.query?.keyWord;
    this.fetchData();
  },
  methods: {
    //统一获取数据
    fetchData() {
      this.tabList = {
        categoryCode:'',
        categoryName:'结果列表',
        list:[]
        }
      this.getArticlePage();

    },
    //获取文章列表
    getArticlePage(page = 1) {
      console.log("getArticlePage-------");
      searchArticle({
        page: page,
        limit: this.pageSize,
        articleName: this.keyWord,
      }).then((res) => {
        if (!res.data) return;

        this.newsList = res.data;
        this.pageCount = Number(res.data.count);
      });
    },
    changeSecTab() {},
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page);
    },
    //跳转详情
    toDetail(item) {
      this.displayNewsList = false;
      this.$router.push({
        path: "/newsList/newsDetail/" + item.articleId + '/' + item.categoryCode,
      });
    },
  },
  mounted() {},
  watch: {
    //监听路由，处理嵌套路由问题
    $route: {
      handler() {
        if (this.$route.path.includes('searchResult')) {
          this.displayNewsList = true;
        } else {
          this.displayNewsList = false;
        }
      },
      // 一进页面就执行
      immediate: true,
      // 深度观察监听
      deep: true,
    },
    '$route.query.keyWord'(newValue) {
      console.log("newValue-------",newValue);

      this.keyWord = newValue;
      this.getArticlePage();
    }
  },
};
</script>

<style lang="scss" scoped>
.news-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #fff;

    .breadcrumb-plate {
      display: flex;
      align-items: center;
      padding: 16px 0;

      .label {
        line-height: 1;
        font-size: 14px;
      }

      .el-breadcrumb {
        cursor: pointer;

        /deep/ .el-breadcrumb__inner.is-link {
          font-weight: normal;
        }
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      .c-left {
        width: 270px;
        flex-shrink: 0;

        margin-right: 15px;
        background-color: #fff;
        // box-shadow: 0 2px 2px rgba($color: #000000, $alpha: 0.05);
        box-shadow: 0px 2px 2px #edeef0;

        .list {
        }
      }

      .c-right {
        flex: 1;
        box-shadow: 0px 2px 2px #edeef0;
        .article-content {
          padding: 0 14px 20px 12px;
          font-size: 17px !important;
          line-height: 2 !important;
          min-height: 640px;
        }
        .m-bot {
          margin-top: 24px;
          margin-bottom: 24px;

          .el-pagination {
            display: flex;
            justify-content: center;

            /deep/ .btn-prev {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-prev:hover:enabled {
              color: #409eff;
            }

            /deep/ .number {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .more {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next:hover:enabled {
              color: #409eff;
            }

            /deep/ .active {
              color: #fff;
              background-color: #409eff;
            }
          }
        }
      }
    }
  }
}
</style>
